module.exports = __webpack_public_path__ + "images/patterns/dark/Scale.68165eca1df968b922d7.svg";